import { useCallback } from 'react';
import ContactsIcon from 'components/SvgIcons/entities/Contacts';
import { CONTACTS } from 'constants/Entities';
import Context from 'managers/Context';
import { getLiteral } from 'utils/getLiteral';
import { successToast } from 'utils/toast';
import colors from 'constants/colors';

const useContactsMerge = () => {
    const { dispatch, getState } = Context.store;
    const { EntityActions, EntityDetailActions, EntityListActions } = Context.actions;
    const state = getState();
    const mergeEntityDialogState = state.entity.mergeEntityDialog;
    const activeList = state.entityList.active;

    const onCloseDialog = useCallback(() => {
        dispatch(EntityActions.closeMergeEntityDialog());
    }, [EntityActions, dispatch]);

    const onMergeSuccess = useCallback(() => {
        successToast({
            text: getLiteral('success_action_ok'),
        });

        onCloseDialog();

        if (activeList === CONTACTS.entity) {
            dispatch(EntityListActions.init(CONTACTS, true, null, null, null, true));
        }

        dispatch(EntityDetailActions.refresh(CONTACTS));
    }, [onCloseDialog, activeList, dispatch, EntityListActions, EntityDetailActions]);

    return {
        entityType: CONTACTS,
        id: mergeEntityDialogState.idEntity,
        id2: mergeEntityDialogState.idEntity2,
        onMergeSuccess,
        onCloseDialog,
        iconEmpty: <ContactsIcon color={colors.grey[100]} />,
        literals: {
            labelTitleModal: 'title_merge_contacts',
            labelTitleConfirm: 'title_merge_contacts',
            labelButtonConfirm: 'action_yes_merge_contacts',
            labelConfirmModalContent: 'label_confirm_merge_contacts',
            labelEntity1Name: 'label_contact1_merge',
            labelEntity2Name: 'label_contact2_merge',
            labelSuggestDuplicates: 'label_suggest_duplicates',
            labelActionMerge: 'action_merge',
            labelActionCancel: 'action_cancel',
            labelActionBack: 'action_back',
            labelActionSelect: 'action_select',
            labelMergeDuplicates: 'label_merge_duplicates',
            labelHelpMergeDuplicates: 'help_merge_duplicates',
            labelNoAccountsToMerge: 'warning_no_accounts_to_merge',
        },
    };
};

export default useContactsMerge;
